import React from 'react';
import getInitialPropsForServicePage from 'helpers/services/getServiceProps';
import { TOP_LEVEL_SERVICE_PAGE } from 'constants/Services';
import { TopLevelServicePage } from 'views/Services';
import configureStore from 'state/configureStore';
import getServerSidePropsWrapper from 'helpers/getServerSidePropsWrapper';

export const VarietyAct = (props) => <TopLevelServicePage {...props} />;

export const getServerSideProps = configureStore.getServerSideProps(
  (store) => async (ctx) =>
    await getServerSidePropsWrapper({ ...ctx, store }, async (ctx) => {
      const { res, req } = ctx;
      return await getInitialPropsForServicePage(
        res,
        store,
        { serviceSlug: 'variety-act-landing' },
        TOP_LEVEL_SERVICE_PAGE,
        req
      );
    })
);

export default VarietyAct;
